import { render, staticRenderFns } from "./MaterialAssets.vue?vue&type=template&id=1cec5fb7&scoped=true"
import script from "./MaterialAssets.vue?vue&type=script&lang=js"
export * from "./MaterialAssets.vue?vue&type=script&lang=js"
import style0 from "./MaterialAssets.vue?vue&type=style&index=0&id=1cec5fb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cec5fb7",
  null
  
)

export default component.exports